module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "bm-title"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Bibliography")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("THE STRUGGLE FOR EUROPE "), _c('i', [_vm._v("by Chester Wilmot")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPRINT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIETY")]), _vm._v(", 1954")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("THE FATAL DECISIONS "), _c('i', [_vm._v("by")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEGRFIED")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTPHAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2012")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("ROMMEL IN HIS OWN WORDS "), _c('i', [_vm._v("Editor Dr John Pimlott")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REENHILL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" 1994")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("WAFFEN-SS COMMANDERS "), _c('i', [_vm._v("by Mark C Yerger")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHIFFER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILITARY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")]), _vm._v(" 1997 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VOLUMES")]), _vm._v(" 1 and 2")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("RUCKMARSCH T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMAN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETREAT")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMANDY")]), _vm._v(" THEN & NOW "), _c('i', [_vm._v("by Jean Paul Pallud")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITAIN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLICATIONS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERNATIONAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(" 2019")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("THE AXIS OCCUPATION OF EUROPE "), _c('i', [_vm._v("by Winston & Gail Ramsey")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _vm._v(", 2018")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("THE DEFEAT OF GERMANY THEN & NOW "), _c('i', [_vm._v("Edited by Winston Ramsey")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _vm._v(", 2015")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("D-DAY T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" & N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLUMES")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(" & T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(" "), _c('i', [_vm._v("by Winston G Ramsey")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITAIN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLICATIONS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERNATIONAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(" 1995")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("ANZIO T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" & N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" "), _c('i', [_vm._v("by Cokonel J. H. Green")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FTER THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGAZINE NO")]), _vm._v(". 52, 1986")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("THE BATTLES FOR MONTE CASSINO T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" & N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('i', [_vm._v("by Jeffrey Plowman/Perry Rowe")]), _vm._v(" AFTER THE BATTLE, 2011")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("THE BOMBER COMMAND WAR DIARIES 1939 - 1945")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('i', [_vm._v("Martin Middlebrook and Chris Everitt")]), _vm._v(", 2014")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("FIGHTER SQUADRONS "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF THE")]), _vm._v(" RAF "), _c('i', [_vm._v("by John D R Rawlings")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACDONALD")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(" 1969")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("THE GREAT PATRIOTIC WAR "), _c('i', [_vm._v("by Peter G Tsouras")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REENHILL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(" 1992")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("Battleground PEGASUS BRIDGE & HORSA BRIDGE "), _c('i', [_vm._v("by")]), _vm._v(" Carl Shilleto")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2013")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Battleground MERVILLE BATTERY & the DIVES BRIDGES "), _c('i', [_vm._v("by")]), _vm._v(" Carl Shilleto")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2011")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Battleground UTAH BEACH/ST MÉRE EGLISE "), _c('i', [_vm._v("by")]), _vm._v(" Carl Shilleto")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2006")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Battleground OMAHA BEACH "), _c('i', [_vm._v("by")]), _vm._v(" Tim Kilvert-Jones")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2003")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Battleground GOLD BEACH (I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLAND FROM")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ING")]), _vm._v(") "), _c('i', [_vm._v("by")]), _vm._v(" Christopher Dunphie & Garry Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2012")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Battleground GOLD BEACH – JIG "), _c('i', [_vm._v("by")]), _vm._v(" Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2002")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Battleground JUNO BEACH Canadian Infantry Division "), _c('i', [_vm._v("by")]), _vm._v(" Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TD")]), _vm._v(", 2004")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("WENN ALLE BRÜDER SCHWEIGEN")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSER")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILDBAND ÜBER DIE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AFFEN")]), _vm._v("-SS, M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNIN")]), _vm._v("-V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERLAG")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MB")]), _vm._v("H, O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SNABRUECK")]), _vm._v(" 1985")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("HISTOIRE D’UN MONDE EN GUERRE 39-45")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('i', [_vm._v("under the direction of Claude Quétel")]), _vm._v(" LAROUSSE 2015")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("ATLANTIKWALL - LE MUR DE ATLANTIQUE EN FRANCE 1940–1944")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAIN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAZETTE")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAIN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTOUCHES")]), _vm._v(" - B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERNARD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AICH")]), _vm._v(" 1995")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("HEITAI J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APANESE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NFANTRYMAN")]), _vm._v(" 1931–1945")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('i', [_vm._v("Agustín Sáiz")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDREA")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")]), _vm._v(", M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADRID")]), _vm._v(" 2011")]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("SNAPDRAGON: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" WWII E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLOITS OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARBY’S")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RNGER")]), _vm._v(" & C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMBAT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHER")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TERN")])])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEB-SITE: ")])]), _c('span', {
    staticClass: "small"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": "http://WWW.LIESLBRADNER.COM",
      "target": "_blank"
    }
  }, [_vm._v("WWW.LIESLBRADNER.COM")])])]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("BATTLE OF SAINTE-MERE-EGLISE B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKSYM")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORNYI")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEB-SITE: WAR-DOCUMENTARY.INFO/SAINTE-MERE-EGLISE-1944/")])]), _vm._v(" "), _c('p', {
    staticClass: "bib1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYLOR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHIC")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RCHIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WORD")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7a0ce30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Bibliography.vue
// module id = 78
// module chunks = 0